<template>
  <div class="submit-success">
    <div class="submit-success-icon">
      <x-svg-icon name="complete-order"></x-svg-icon>
    </div>
    <div v-if="!this.$route.query.type" class="submit-success-help">
      提交成功，<span class="submit-success-resubmit" @click="handleClick">再次填写</span>
    </div>
    <div v-if="this.$route.query.type" class="submit-success-help">
      提交成功
    </div>
    <div v-if="editUrl" class="edit-form">
      <div class="edit-url">
        {{ editUrl }}
      </div>
      <div class="edit-url-describe">
        长按复制链接，可通过此链接编辑修改已提交的数据
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      prevRouter: {}
    }
  },
  computed: {
    editUrl() {
      if (!this.$route.query.editUrl) {
        return ''
      } else return this.$route.query.editUrl
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRouter = {
        name: from.name,
        query: from.query
      }
    })
  },
  methods: {
    handleClick() {
      this.$router.push(this.prevRouter)
    }
  }
}
</script>

<style lang="scss">
.submit-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.86rem 0;
  .submit-success-icon {
    width: 8.57rem;
    height: 8.57rem;
    margin-bottom: 1.71rem;
    .svg-icon {
      width: 8.57rem !important;
      height: 8.57rem !important;
    }
  }
  .submit-success-help {
    font-size: $--app-base-font-size;
    color: $--app-notice-color;
    .submit-success-resubmit {
      cursor: pointer;
      color: $--app-primary-color;
    }
  }
  .edit-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 2.5rem;
    font-size: $--app-base-font-size;
    color: $--app-notice-color;
    .edit-url {
      text-align: center;
      margin-bottom: 0.9375rem;
      -webkit-user-select:text;
      -moz-user-select:text;
      -ms-user-select:text;
      user-select:text;
      word-break:break-all;
      word-wrap:break-word;
      padding: 0 30px;
    }
    .edit-url-describe {
      cursor: pointer;
    }
  }
}
</style>
